var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "map-row" },
    [
      _vm._t("default"),
      _c(
        "div",
        { staticClass: "map-col-12" },
        [
          _c(_setup.inputText, {
            attrs: { label: _setup.$map.trans("map.layer-control.field.url") },
            model: {
              value: _setup.form.url,
              callback: function ($$v) {
                _vm.$set(_setup.form, "url", $$v)
              },
              expression: "form.url",
            },
          }),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "map-col-6" },
        [
          _c(_setup.inputText, {
            attrs: {
              label: _setup.$map.trans("map.layer-control.field.minzoom"),
            },
            model: {
              value: _setup.form.minzoom,
              callback: function ($$v) {
                _vm.$set(_setup.form, "minzoom", $$v)
              },
              expression: "form.minzoom",
            },
          }),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "map-col-6" },
        [
          _c(_setup.inputText, {
            attrs: {
              label: _setup.$map.trans("map.layer-control.field.maxzoom"),
            },
            model: {
              value: _setup.form.maxzoom,
              callback: function ($$v) {
                _vm.$set(_setup.form, "maxzoom", $$v)
              },
              expression: "form.maxzoom",
            },
          }),
        ],
        1
      ),
      _setup.form.bounds
        ? [
            _c(
              "div",
              { staticClass: "map-col-6" },
              [
                _c(_setup.inputText, {
                  attrs: {
                    label: _setup.$map.trans(
                      "map.layer-control.field.bound.minx"
                    ),
                  },
                  model: {
                    value: _setup.form.bounds[0],
                    callback: function ($$v) {
                      _vm.$set(_setup.form.bounds, 0, $$v)
                    },
                    expression: "form.bounds[0]",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "map-col-6" },
              [
                _c(_setup.inputText, {
                  attrs: {
                    label: _setup.$map.trans(
                      "map.layer-control.field.bound.miny"
                    ),
                  },
                  model: {
                    value: _setup.form.bounds[1],
                    callback: function ($$v) {
                      _vm.$set(_setup.form.bounds, 1, $$v)
                    },
                    expression: "form.bounds[1]",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "map-col-6" },
              [
                _c(_setup.inputText, {
                  attrs: {
                    label: _setup.$map.trans(
                      "map.layer-control.field.bound.maxx"
                    ),
                  },
                  model: {
                    value: _setup.form.bounds[2],
                    callback: function ($$v) {
                      _vm.$set(_setup.form.bounds, 2, $$v)
                    },
                    expression: "form.bounds[2]",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "map-col-6" },
              [
                _c(_setup.inputText, {
                  attrs: {
                    label: _setup.$map.trans(
                      "map.layer-control.field.bound.maxy"
                    ),
                  },
                  model: {
                    value: _setup.form.bounds[3],
                    callback: function ($$v) {
                      _vm.$set(_setup.form.bounds, 3, $$v)
                    },
                    expression: "form.bounds[3]",
                  },
                }),
              ],
              1
            ),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }